import { SaveOrdersReportUsecase, SaveOrdersReportUsecaseImp } from 'domain/usecases/save-orders-report-usecase';
import { makeSaveOrdersReportRepository } from '../repositories/cache/orders-history-cache-repository-factory';

export const makeSaveOrdersReportUsecase = (): SaveOrdersReportUsecase => {
  return new SaveOrdersReportUsecaseImp(makeSaveOrdersReportRepository());
};
